import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCardSkeleton } from './TypeCard';
import type { TypeCtaSkeleton } from './TypeCta';

export interface TypeBlockContentFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title?: EntryFieldTypes.Symbol;
    colorOption?: EntryFieldTypes.Symbol<'color-dark-purple' | 'color-no-background'>;
    cards?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCardSkeleton>>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockContentSkeleton = EntrySkeletonType<TypeBlockContentFields, 'blockContent'>;
export type TypeBlockContent<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockContentSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockContent<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockContent<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockContent';
}
